// 출퇴근 기록 한 줄 (2026-09-14 분리)
// AttendanceSection 이 313줄이 돼 300줄 규칙에 걸려, 목록 항목 하나를 통째로 옮겼다.
// **코드 이동만이고 동작 변경은 없다.**
//   날짜 줄 + 칩 3개 + 상세 패널(IP/주소/지각/휴게 편집).

import React from 'react';
import { diffMinutes as dateDiffMinutes } from '../../utils/date';
import {
  itemWrapClass, itemBtnClass, itemTopRowClass, dateLabelRowClass, lateDotClass,
  toggleLabelClass, chipRowClass, chipClass,
  detailBoxClass, detailLineClass,
  breakEditorRowClass, breakEditorRowStyle, breakEditorLabelClass,
  breakInputClass, miniSaveBtnClass, detailHintClass,
} from './attendanceSectionStyles';
import { formatIpWithAlias } from './attendanceIp';

// dateDiffMinutes: utils/date.js 사용 (new Date 직접 사용 금지)
function diffMinutes(start, end) {
  if (!start || !end) return null;
  const diff = dateDiffMinutes(start, end);
  if (!Number.isFinite(diff) || diff <= 0) return null;
  return diff;
}
function breakMinutesByPolicy(totalMinutes) {
  if (!Number.isFinite(totalMinutes)) return null;
  if (totalMinutes >= 390) return 120;
  if (totalMinutes >= 4 * 60) return 30;
  return 0;
}

export default function AttendanceRecordItem({
  row, itemKey: key, opened, summary,
  fmtDate, weekdayOne,
  breakDraftById, savingBreakById,
  onToggleDetail, onBreakDraftChange, onSaveBreak,
}) {
  const autoRest = breakMinutesByPolicy(diffMinutes(row?.check_in, row?.check_out));
  const lateMinutes = Number(row?.late_minutes);
  const isLate = Number.isFinite(lateMinutes) && lateMinutes > 0;

  return (
        <div key={key} className={itemWrapClass(opened)}>
          <button type="button" className={itemBtnClass} onClick={() => onToggleDetail(key)}>
            <div className={itemTopRowClass}>
              <div className={dateLabelRowClass}>
                {fmtDate(row.date)} ({weekdayOne(row.date)})
                {isLate && (
                  <span className={lateDotClass} title={`지각 ${lateMinutes}분`} />
                )}
              </div>
              <span className={toggleLabelClass(opened)}>
                {opened ? '상세 접기' : '상세 보기'}
              </span>
            </div>
            <div className={chipRowClass}>
              <span className={chipClass}>☀️ {summary.checkIn}~{summary.checkOut}</span>
              <span className={chipClass}>⏱ {summary.worked}</span>
              <span className={chipClass}>☕ {summary.rest}</span>
            </div>
          </button>

          {/* 상세 패널 */}
          {opened && (
            <div className={detailBoxClass}>
              <div className={detailLineClass}>출근 IP: {formatIpWithAlias(row.ip_address, row.check_in_ip_label)}</div>
              <div className={detailLineClass}>출근 주소: {row.check_in_address || '-'}</div>
              <div className={detailLineClass}>퇴근 IP: {formatIpWithAlias(row.check_out_ip_address, row.check_out_ip_label)}</div>
              <div className={detailLineClass}>퇴근 주소: {row.check_out_address || '-'}</div>
              <div className={detailLineClass}>등록 IP: {formatIpWithAlias(row.registered_ip_address, row.registered_ip_label)}</div>
              {isLate && <div className={detailLineClass}>지각: {lateMinutes}분</div>}
              {row.late_reason && <div className={detailLineClass}>지각 사유: {row.late_reason}</div>}

              {/* 휴게시간 편집 행 */}
              <div className={breakEditorRowClass} style={breakEditorRowStyle}>
                <label className={breakEditorLabelClass} htmlFor={`break-${row.id}`}>
                  휴게시간(분)
                </label>
                <input
                  id={`break-${row.id}`}
                  type="number" min="0" max="600" step="1"
                  className={breakInputClass}
                  value={breakDraftById[row.id] ?? ''}
                  placeholder={Number.isFinite(autoRest) ? `${autoRest}` : '0'}
                  onChange={e => onBreakDraftChange(row.id, e.target.value)}
                />
                <button
                  type="button"
                  className={miniSaveBtnClass}
                  disabled={Boolean(savingBreakById[row.id])}
                  onClick={() => onSaveBreak(row)}
                >
                  {savingBreakById[row.id] ? '저장중' : '저장'}
                </button>
              </div>
              <div className={detailHintClass}>기본 자동값: 6.5시간 이상 90분, 4시간 이상 30분</div>
            </div>
          )}
        </div>
  );
}
